
import { Component, Vue, Prop } from 'vue-property-decorator';
import {
    WechatUploaderComponent, WechatImage,
} from '@forzoom/uploader';
import { pathGet, pathSet } from '@/lib/service/storage';
import { dateNow, dateOffset, dateFormat } from '@/lib/utils';
import { WX_SERVER_ID_VALID_DAY } from '@/lib/constant';
/**
 * 班级头像上传逻辑
 *
 * - @add 数据添加
 * - @remove 数据删除
 */
@Component({
    name: 'SingleUploader',
})
export default class AvatarUploader extends Vue {
    /** 模式 */
    @Prop({ type: String, default: 'wechat' }) public mode!: 'input' | 'wechat';
    /** 提示内容 */
    @Prop({ type: String }) public hint!: any;
    /** 背景样式类 */
    @Prop({ type: [ Object, Array] }) public backgroundStyle!: any;
    /** 删除按钮的样式 */
    @Prop({ type: [ Object, Array ] }) public removeClass: any;
    /** 是否未填写 */
    @Prop({ type: Boolean, default: false }) public blank!: any;
    /** 是否可以修改图片 */
    @Prop({ type: Boolean, default: true }) public canModify!: boolean;
    /** uploader的class */
    @Prop({}) public uploaderClass: any;
    /** 存储localStorage的key，只应该在数据的创建流程中存在，在update流程中存在逻辑上有问题 */
    @Prop({ type: String }) public storeKey?: string;

    @Prop({ type: String }) public accept!: string;

    /** 图片内容，存放url或者是localId */
    public image: string | null = null;
    /** mask是否可见 */
    public maskVisible: boolean = false;

    public get opacity() {
        return this.image ? 1 : 0;
    }

    /**
     * 获得元素
     *
     * @return {} uploader
     */
    public getImage() {
        return this.image;
    }
    /**
     * 设置头像
     *
     * @param {} image 头像内容
     */
    public setImage(image: string) {
        const $uploader = this.$refs.uploader as WechatUploaderComponent;
        $uploader.setImages([
            {
                url: image,
                image,
                serverId: null,
            },
        ]);
        this.image = image;
    }
    /**
     * 删除当前的图片信息
     */
    public removeImage() {
        const $uploader = this.$refs.uploader as WechatUploaderComponent;
        $uploader.setImages([]);
    }
    /**
     * 数据开始加载
     */
    public onLoad() {
        this.maskVisible = true;
        this.$emit('load');
    }
    /**
     * 图片加载完成
     */
    public onFinish() {
        this.maskVisible = false;
        this.$emit('finish');
    }
    /**
     * add事件
     *
     *  {image, serverId}
     */
    public onAdd(...args: WechatImage[]) {
        const $uploader = this.$refs.uploader as WechatUploaderComponent;
        const images = $uploader.getImages();
        this.image = images[0].url;
        if (this.storeKey) {
            pathSet(this.storeKey, {
                key: images[0].key,
                url: images[0].url,
                serverId: images[0].serverId,
            }, dateFormat(dateOffset(dateNow(), WX_SERVER_ID_VALID_DAY), 'Y-m-d H:i:s'));
        }
        this.$emit('add', ...args);
    }
    /**
     * remove事件
     *
     *  {} 可能没有数据
     */
    public onRemove(...args: WechatImage[]) {
        this.image = null;
        this.$emit('remove', ...args);
        const $uploader = this.$refs.uploader as WechatUploaderComponent;
        $uploader.request();
    }

    public mounted() {
        if (this.storeKey) {
            const result = pathGet(this.storeKey);
            if (result) {
                const resultJSON = JSON.parse(result);
                const $uploader = this.$refs.uploader as WechatUploaderComponent;
                if ($uploader) {
                    $uploader.add({
                        url: resultJSON.url || resultJSON.image,
                        image: resultJSON.url || resultJSON.image,
                        serverId: resultJSON.serverId,
                    });
                    this.image = resultJSON.url;
                }
            }
        }
    }
}
